import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useGetFactories from '../../../../api/factories/useGetFactories';
import { VEHICLE_COLORS } from '../../../../pages/Vehicles/components/vehicle-color-picker';
import { VEHICLE_TYPES } from '../../../../pages/Vehicles/components/vehicle-type-radio';
import { VcField } from './vehicle-form-fields';

export default function VehicleGeneralInfoStep({
  vehicleData,
  setVehicleData,
}) {
  const { factories, isLoading: isLoadingFactories } = useGetFactories();

  const handleChange = (field, value) => {
    setVehicleData({ ...vehicleData, [field]: value });
  };

  const selectedColor = VEHICLE_COLORS.find(
    (color) => color.value === vehicleData.color
  );

  return (
    <div className="vd vc-step">
      <section className="vd-section">
        <div className="vd-section__head">
          <div>
            <h3 className="vd-section__title">Identification</h3>
            <p className="vd-section__description">
              Ce qui permet de reconnaître le véhicule et de joindre le
              chauffeur.
            </p>
          </div>
        </div>
        <div className="vd-grid">
          <VcField
            label="Numéro du camion"
            required
            hint="Identifiant unique, non modifiable ensuite"
          >
            <input
              className="vd-input"
              type="number"
              min="0"
              value={vehicleData.CAMION}
              onChange={(e) => handleChange('CAMION', e.target.value)}
              placeholder="Ex : 123"
              autoFocus
            />
          </VcField>
          <VcField label="Libellé" required>
            <input
              className="vd-input"
              value={vehicleData.LIBCAM}
              onChange={(e) => handleChange('LIBCAM', e.target.value)}
              placeholder="Ex : Camion frigorifique"
            />
          </VcField>
          <VcField label="Immatriculation" required>
            <input
              className="vd-input vd-input--upper"
              value={vehicleData.IMMAT}
              onChange={(e) =>
                handleChange('IMMAT', e.target.value.toUpperCase())
              }
              placeholder="AA-123-BB"
            />
          </VcField>
          <VcField label="Téléphone du camion" required>
            <input
              className="vd-input"
              type="tel"
              value={vehicleData.TELCAM}
              onChange={(e) => handleChange('TELCAM', e.target.value)}
              placeholder="06 12 34 56 78"
            />
          </VcField>
        </div>
      </section>

      <section className="vd-section">
        <div className="vd-section__head">
          <div>
            <h3 className="vd-section__title">Exploitation</h3>
            <p className="vd-section__description">
              Le site de rattachement sert de point de départ des tournées.
            </p>
          </div>
        </div>
        <div className="vd-grid">
          <VcField label="Transporteur" required>
            <input
              className="vd-input"
              value={vehicleData.TRANSP}
              onChange={(e) => handleChange('TRANSP', e.target.value)}
              placeholder="Ex : Transport SA"
            />
          </VcField>
          <VcField label="Site de rattachement" hint="Facultatif">
            <select
              className="vd-input"
              value={vehicleData.factory_id || ''}
              onChange={(e) => handleChange('factory_id', e.target.value)}
              disabled={isLoadingFactories}
            >
              <option value="">Aucun site</option>
              {Array.isArray(factories) &&
                factories.map((factory) => (
                  <option key={factory.id} value={factory.id}>
                    {factory.name}
                  </option>
                ))}
            </select>
          </VcField>
        </div>
        <div className="vd-field vd-field--wide">
          <span className="vd-field__label">
            Type de véhicule
            <span className="vc-required">requis</span>
          </span>
          <div className="vd-chips" role="radiogroup">
            {VEHICLE_TYPES.map((type) => (
              <button
                key={type.value}
                type="button"
                role="radio"
                aria-checked={vehicleData.LIBTYP === type.value}
                className={`vd-chip ${
                  vehicleData.LIBTYP === type.value ? 'vd-chip--active' : ''
                }`}
                onClick={() => handleChange('LIBTYP', type.value)}
              >
                <FontAwesomeIcon icon={type.icon} />
                {type.value}
              </button>
            ))}
          </div>
          {vehicleData.LIBTYP === 'Citerne compartimentée' && (
            <span className="vd-field__hint">
              Vous définirez chaque compartiment à l&apos;étape suivante.
            </span>
          )}
        </div>
        <div className="vd-field vd-field--wide">
          <span className="vd-field__label">
            Couleur sur la carte
            <span className="vd-field__inline">
              {selectedColor?.label || vehicleData.color}
            </span>
          </span>
          <div className="vd-swatches" role="radiogroup">
            {VEHICLE_COLORS.map((color) => (
              <button
                key={color.value}
                type="button"
                role="radio"
                aria-checked={vehicleData.color === color.value}
                aria-label={color.label}
                title={color.label}
                className={`vd-swatch ${
                  vehicleData.color === color.value ? 'vd-swatch--active' : ''
                }`}
                style={{ backgroundColor: color.value }}
                onClick={() => handleChange('color', color.value)}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
